import { Input } from '@vwfs-bronson/bronson-react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { validateDateMax } from '../../../helpers'
import { FormField } from '../../common/FormField'

export const FirstName = () => {
  const { t } = useTranslation('signinpage')
  return (
    <FormField
      infoIcon={t("firstName.tooltip")}
      name="firstName"
      labelText={t("firstName.name")}
      required
      type="input"
      render={(fieldProps: any) => <Input {...fieldProps} autoComplete={'given-name'} />}
    />
  )
}

export const SurName = () => {
  const { t } = useTranslation('signinpage')
  return (
    <FormField
        infoIcon={t("surName.tooltip")}
        name="surName"
        labelText={t("surName.name")}
        required
        type="input"
        className="u-mt-small"
        render={(fieldProps: any) => <Input {...fieldProps} autoComplete={'family-name'} />}
    />
  )
}

export const DateOfBirth = () => {
  const { t } = useTranslation('signinpage')
  const { setFieldValue } = useFormikContext<any>()
  const allowedDateCharsRegexp = new RegExp(/^[0-9/]*$/)
  const pastedDifferentDateFormatRegexp = new RegExp(/^\d{2}-\d{2}-\d{4}$/)
  const handleChangeDate = (e: any) => {
    const lastInput = e.nativeEvent?.data;
    const value = e.target.value;

    if (pastedDifferentDateFormatRegexp.test(value)) {
      const formattedDate = value.replaceAll('-', '/');
      validateDateMax(formattedDate);
      setFieldValue("dateOfBirth", formattedDate);
    } else {
      if (!allowedDateCharsRegexp.test(value)) {
        return;
      }
      if ((value.length === 3 || value.length === 6) && lastInput !== "/" && lastInput !== null) {
        setFieldValue("dateOfBirth", value.substring(0, value.length - 1) + "/" + lastInput);

        return;
      }
      validateDateMax(value);
      setFieldValue("dateOfBirth", value);
    }
  };
  return (
    <FormField
      infoIcon={t("dateOfBirth.tooltip")}
      name="dateOfBirth"
      labelText={t("dateOfBirth.name")}
      required
      type="input"
      className="u-mt-small"
      render={(fieldProps: any) =>
        <Input
            {...fieldProps}
            onChange={(e) => handleChangeDate(e)}
            autoComplete={'bday'}
        />}
    />
  )
}

export const CustomerNumber = () => {
  const { t } = useTranslation('signinpage')
  return (
    <FormField
        infoIcon={t("customerNumber.tooltip")}
        name="customerNumber"
        labelText={t("customerNumber.name")}
        required
        type="input"
        render={(fieldProps: any) => <Input {...fieldProps} maxLength={10} />}
    />
  )
}

export const CompanyName = () => {
  const { t } = useTranslation('signinpage')
  return (
    <FormField
      infoIcon={t("companyName.tooltip")}
      name="companyName"
      labelText={t("companyName.name")}
      required
      type="input"
      className="u-mt-small"
      render={(fieldProps: any) => <Input {...fieldProps} />}
    />
  )
}

export const Siren = () => {
  const { t } = useTranslation('signinpage')
  return (
    <FormField
      infoIcon={t("siren.tooltip")}
      name="siren"
      labelText={t("siren.name")}
      required
      type="input"
      className="u-mt-small"
      render={(fieldProps: any) => <Input {...fieldProps} maxLength={9} />}
    />
  )
}
